import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class EvaluationsService {

    constructor(private http: HttpClient) { }

    getPendings(page, search) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/evaluations/pending`, body, { headers });
    }

    getPendingCertificate(page, search) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/evaluations/pendingCertificates`, body, { headers });
    }

    getPendingCertificationNOP(page, search) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/evaluations/pendingCertificationNOP`, body, { headers });
    }

    getDone(page, search) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/evaluations/done`, body, { headers });
    }

    getNotAnnouncedDone(page, search) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/evaluations/notAnnouncedDone`, body, { headers });
    }

    assign(evaluationId, dictatorId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const payload = {}

        return this.http.patch<any>(`${environment.apiUrl}/evaluations/${evaluationId}/assign/${dictatorId}`, payload, { headers });
    }

    getEvaluation(evaluationId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/evaluations/${evaluationId}`, { headers });
    }

    getEvaluationNotAnnounced(evaluationId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/evaluations/notAnnounced/${evaluationId}`, { headers });
    }

    generateNotAnnouncedResult(evaluationId, payload) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Authorization': jwtToken
        };

        return this.http.post<any>(`${environment.apiUrl}/evaluations/${evaluationId}/result/notAnnounced`, payload, { headers });
    }

    getForm(evaluationId, formId, isAnInspection = false, inspectionId = 0, inspectorId = 0) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const isInspection = isAnInspection ? 1 : 0

        return this.http.get<any>(`${environment.apiUrl}/evaluations/${evaluationId}/form/${formId}/${isInspection}/${inspectionId}/${inspectorId}`, { headers });
    }

    evaluationComments(evaluationId, formId, comments, isINA, inspectorId = 0) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const payload = {
            comments: comments,
            isINA: isINA,
        }

        return this.http.patch<any>(`${environment.apiUrl}/evaluations/${evaluationId}/${inspectorId}/form/${formId}/comments`, payload, { headers });
    }

    getUrlStatus(url: string) {
        return this.http.get(url);
    }

    searchUser(query: string) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/evaluations/committee/search/${query}`, { headers }).pipe(
            map(response => {
                //console.log(response['data'])
                return response['data']
            })
        );
        
    }

    addCommitteeUser(evaluationId, userId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const payload = {}

        return this.http.post<any>(`${environment.apiUrl}/evaluations/${evaluationId}/committee/add/${userId}`, payload, { headers });
    }

    removeCommitteeUser(evaluationId, userId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const payload = {}

        return this.http.delete<any>(`${environment.apiUrl}/evaluations/${evaluationId}/committee/remove/${userId}`, { headers });
    }

    signEvaluation(evaluationId, formId, formData, inspectorId = 0) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        let body = {
            submission: []
        }
        for (var i in Object.keys(formData)) {
            const key = Object.keys(formData)[i]
            body.submission.push({
                name: key,
                value: formData[key]
            })
        }

        return this.http.patch<any>(`${environment.apiUrl}/evaluations/${evaluationId}/${inspectorId}/form/${formId}/review`, body, { headers });
    }

    dictaminationResult(evaluationId, payload) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Authorization': jwtToken
        };

        return this.http.post<any>(`${environment.apiUrl}/evaluations/${evaluationId}/result`, payload, { headers });
    }

    getDictaminationResult(evaluationId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/evaluations/${evaluationId}/result`, { headers });
    }

    getNotAnnouncedResult(evaluationId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/evaluations/${evaluationId}/resultNotAnnounced`, { headers });
    }

    generateCertificate(recordId, version) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const payload = {}

        return this.http.post<any>(`${environment.apiUrl}/certificates/generatePdf/${recordId}/${version}`, payload, { headers });
    }

    uploadCertificateUE(evaluationId, payload) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Authorization': jwtToken
        };

        return this.http.post<any>(`${environment.apiUrl}/evaluations/uploadCertificate/${evaluationId}`, payload, { headers });
    }

    uploadCertificateNOP(evaluationId, payload) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Authorization': jwtToken
        };

        return this.http.post<any>(`${environment.apiUrl}/evaluations/uploadCertificateNOP/${evaluationId}`, payload, { headers });
    }

    getDictators() {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/evaluations/dictators`, { headers });
    }

    getToValidate(page, search) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/evaluations/toValidate`, body, { headers });
    }

    getExpired(page, search) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/evaluations/expired`, body, { headers });
    }

    validateInspection(evaluationId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const payload = {}

        return this.http.patch<any>(`${environment.apiUrl}/evaluations/${evaluationId}/validate`, payload, { headers });
    }

    reprogramInspection(evaluationId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const payload = {}
        
        return this.http.delete<any>(`${environment.apiUrl}/evaluations/${evaluationId}/reprogram`, { headers });
    }

    saveForm(evaluationId, formId, form, notChange = false) {
        let body = {
            submission: []
        }

        if (!notChange) {
            for (var i in Object.keys(form)) {
                const key = Object.keys(form)[i]
                body.submission.push({
                    name: key,
                    value: form[key]
                })
            }
        } else {
            body.submission = form
        }

        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.post<any>(`${environment.apiUrl}/evaluations/${evaluationId}/form/${formId}/submit`, body, { headers });
    }
}